const BlogIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path d='M9.12823 1.08398C4.50836 1.08398 0.75 4.82792 0.75 9.43008C0.75 14.0322 4.50836 17.7762 9.12823 17.7762C13.7481 17.7762 17.5065 14.0322 17.5065 9.43008C17.5065 4.82792 13.7481 1.08398 9.12823 1.08398ZM9.12823 17.0801C4.89385 17.0801 1.44878 13.6482 1.44878 9.43008C1.44878 5.21194 4.89385 1.78008 9.12823 1.78008C13.3626 1.78008 16.8077 5.21194 16.8077 9.43008C16.8077 13.6482 13.3626 17.0801 9.12823 17.0801Z' />
        <path d='M2.73338 6.64844C2.35805 7.50159 2.14648 8.44086 2.14648 9.4308C2.14648 12.2466 3.838 14.6723 6.25982 15.7646L3.0375 6.64844H2.73338Z' />
        <path d='M6.33552 6.29953C6.33552 6.49205 6.17989 6.64708 5.98664 6.64708H5.78524L7.74223 12.6961C8.09925 11.6829 8.46644 10.6291 8.75124 9.78915L7.64052 6.64809H7.38216C7.1889 6.64809 7.03328 6.49306 7.03328 6.30055C7.03328 6.10803 7.1889 5.95301 7.38216 5.95301H10.5241C10.7174 5.95301 10.873 6.10803 10.873 6.30055C10.873 6.49306 10.7174 6.64809 10.5241 6.64809H10.3878L12.3448 12.6972C12.7507 11.5451 13.1718 10.3343 13.4677 9.45174C13.602 8.78401 13.0822 7.94605 12.6205 7.20233C12.2614 6.62377 11.9512 6.12323 11.9512 5.69665C11.9512 4.39463 12.712 4.20009 13.1657 4.20009C13.4393 4.20009 13.6885 4.27304 13.9183 4.38551C12.6673 3.2061 10.9829 2.47656 9.12758 2.47656C6.55013 2.47656 4.30021 3.87889 3.09082 5.95401H5.98664C6.17989 5.95401 6.33552 6.10905 6.33552 6.30156V6.29953Z' />
        <path d='M7.26367 16.1275C7.85769 16.2917 8.4812 16.3869 9.12708 16.3869C9.77297 16.3869 10.3955 16.2927 10.9895 16.1275L9.12505 10.8516C8.4578 12.7858 7.57085 15.2703 7.26469 16.1275H7.26367Z' />
        <path d='M14.7983 5.38867C15.0841 6.2783 14.7332 7.79209 14.3629 8.96036C14.3029 9.15085 14.2276 9.37883 14.1422 9.63518C14.1341 9.67064 14.1249 9.70509 14.1147 9.74055C14.1066 9.7669 14.0954 9.79324 14.0822 9.81655C13.4871 11.5826 12.4619 14.4673 11.998 15.7633C14.4189 14.67 16.1104 12.2453 16.1104 9.4305C16.1104 7.92279 15.6211 6.52959 14.7993 5.38969L14.7983 5.38867Z' />
      </svg>
    </span>
  );
};

export default BlogIcon;
